const _roundTo = (input, precision = 0) =>
  Math.floor(input * Math.pow(10, precision)) / Math.pow(10, precision)

const transformSpan = (value) =>
  typeof value === 'string' ? value : `${_roundTo((value / 12) * 100, 5)}%`

export default transformSpan
